export default function (state, data) {
    state.items = [];
    if (data && data.Items) {
        data.Items.forEach(i => {
            state.items.push({
                value: i.Id,
                label: i.Name + ' ' + i.FirstName + ' ' + i.MiddleName,
                type: 'client',
                ...i
            });
        });
        state.tab = 'list';
    }else{
        state.tab = 'form';
    }
    state.loading = false;
}